import { createReducer, on } from '@ngrx/store';
import * as CommonStoreActions from './common-store.actions';
import { HelpLink, Nuclide } from '../models';
import { Constants } from '../models/constants';

export const commonStoreFeatureKey = 'commonStore';

export interface State {
    helpLinks: HelpLink[];
    constants?: Constants;
    nuclides?: Nuclide[];
}

export const initialState: State = {
    helpLinks: [],
};

export const reducer = createReducer(
    initialState,

    on(CommonStoreActions.loadCommonStores, (state) => state),
    on(CommonStoreActions.loadHelpLinksSuccess, (state, action) => {
        return {
            ...state,
            helpLinks: action.helpLinks,
        };
    }),
    on(CommonStoreActions.loadConstants, (state, action) => {
        return {
            ...state,
            constants: action.constants,
        };
    }),
    on(CommonStoreActions.loadNuclidesSuccess, (state, action) => {
        return {
            ...state,
            nuclides: action.nuclides,
        };
    })
);
